export default {
  flagMessage: {
    button: {
      completedText: 'Message Reported',
      defaultText: 'Report message',
      modalTitle: 'Report message',
    },
    form: {
      reasonSelect: {
        label: 'Reason',
        option: {
          abuse: 'Abuse',
          fraud: 'Fraud',
          offsite: 'Off-site/unprotected transaction',
          spam: 'Spam',
        },
      },
      button: {
        loadingText: 'Please wait...',
        defaultText: 'Submit',
      },
    },
  },
};
